import React from 'react';
import { Icon } from '@iconify/react';
import {
  AppBadge,
  AppButton,
  AppEmptyState,
  AppFormField,
  AppInput,
  AppModal,
  AppPillSwitch,
  AppSpinner,
} from '../../ui';
import MagazineMedia from './MagazineMedia';
import {
  BUCKET_LABELS,
  BUCKET_OPTIONS,
  bucketVariant,
  primaryStatut,
} from './magazineHelpers';

function KlubMagazinePickerModal({
  show,
  busy,
  pickerKind,
  candidateSearch,
  candidateBucket,
  selectedCandidateIds,
  activeCandidateSource,
  flatCandidates,
  filteredCandidates,
  commercants,
  offres,
  onClose,
  onChangeSearch,
  onChangeBucket,
  onToggleCandidate,
  onAddSelected,
}) {
  return (
    <AppModal
      show={show}
      title={pickerKind === 'offres' ? 'Ajouter des offres' : 'Ajouter des commerçants'}
      onClose={onClose}
      size="lg"
      scrollable
      footer={(
        <>
          <AppButton variant="outline-secondary" onClick={onClose}>Annuler</AppButton>
          <AppButton
            variant="primary"
            loading={busy}
            disabled={!selectedCandidateIds.length}
            onClick={onAddSelected}
          >
            Ajouter ({selectedCandidateIds.length})
          </AppButton>
        </>
      )}
    >
      <AppFormField label="Recherche" htmlFor="candidate-search" className="mb-2">
        <AppInput
          id="candidate-search"
          value={candidateSearch}
          onChange={(e) => onChangeSearch(e.target.value)}
          placeholder={pickerKind === 'offres' ? 'Commerçant, description…' : 'Nom, dirigeant, slug…'}
        />
      </AppFormField>
      <div className="mb-3">
        <AppPillSwitch
          ariaLabel="Filtrer par statut magazine"
          value={candidateBucket}
          onChange={onChangeBucket}
          options={BUCKET_OPTIONS.map((opt) => {
            const already = pickerKind === 'offres'
              ? (id) => offres.some((x) => x.offre_id === id)
              : (id) => commercants.some((x) => x.commercant_id === id);
            return {
              ...opt,
              count: opt.value === 'all'
                ? flatCandidates.filter((c) => !already(c.id)).length
                : flatCandidates.filter((c) => (
                  !already(c.id) && (c.buckets ?? []).includes(opt.value)
                )).length,
            };
          })}
        />
      </div>
      {!activeCandidateSource ? (
        <AppSpinner />
      ) : filteredCandidates.length === 0 ? (
        <AppEmptyState message="Aucun candidat disponible." />
      ) : (
        <div className="klub-magazine-grid klub-magazine-picker-grid">
          {filteredCandidates.map((c) => {
            const selected = selectedCandidateIds.includes(c.id);
            const statut = primaryStatut(c);
            const title = pickerKind === 'offres' ? (c.commercant_label || '—') : c.nom;
            const metaPrimary = pickerKind === 'offres' ? c.description : c.activite;
            const metaSecondary = pickerKind === 'offres' ? null : c.dirigeant;
            return (
              <button
                key={c.id}
                type="button"
                className={`klub-magazine-card klub-magazine-card--selectable${selected ? ' is-selected' : ''}`}
                onClick={() => onToggleCandidate(c.id)}
                aria-pressed={selected}
              >
                <span className="klub-magazine-card__check" aria-hidden>
                  <Icon icon={selected ? 'mdi:check' : 'mdi:plus'} />
                </span>
                {c.is_nouveau ? (
                  <div className="klub-magazine-card__badge">
                    <AppBadge variant="none" pill className="klub-magazine-nouveau-tag is-active">Nouveauté</AppBadge>
                  </div>
                ) : null}
                <div className="klub-magazine-card__media" title={c.photo_path || undefined}>
                  <MagazineMedia
                    path={c.photo_path}
                    fallbackIcon={pickerKind === 'offres' ? 'mdi:tag-outline' : 'mdi:account-tie'}
                    alt={title || ''}
                  />
                </div>
                <div className="klub-magazine-card__body">
                  <p className="klub-magazine-card__title">{title}</p>
                  {metaPrimary ? (
                    <p className="klub-magazine-card__meta">{metaPrimary}</p>
                  ) : null}
                  {metaSecondary ? (
                    <p className="klub-magazine-card__meta">{metaSecondary}</p>
                  ) : null}
                </div>
                {statut ? (
                  <div className="klub-magazine-card__statut">
                    <AppBadge variant={bucketVariant(statut)} pill>
                      {BUCKET_LABELS[statut] || statut}
                    </AppBadge>
                  </div>
                ) : null}
              </button>
            );
          })}
        </div>
      )}
    </AppModal>
  );
}

export default KlubMagazinePickerModal;
